import { Component, Prop, Event, EventEmitter, h } from '@stencil/core';
import { Color } from '../../interface';

@Component({
  tag: 'lar-door-content',
  shadow: false,
  scoped: false
})
export class DoorContent {
   @Prop() color?: Color;
   @Prop() disabled?: boolean;
   @Prop() value: string;
   // @Event() click!: EventEmitter; // populates

   render() {
    return (
      <lar-button
        disabled={this.disabled}
        color={this.color}>
        <lar-translate t={this.value} />
      </lar-button>
    );
  }
}